<history-card [data]="history" defaultFieldType="OfferField" changeType="OfferChangeType" [expanded]="false"></history-card>